import html2canvas from 'html2canvas';

/**
 * Web-only: capture a React ref's DOM node as PNG, then share or download.
 */
export async function shareCard(viewRef: React.RefObject<any>): Promise<void> {
  const node = viewRef.current as unknown as HTMLElement;
  if (!node) throw new Error('shareCard: ref not attached');

  const canvas = await html2canvas(node, {
    backgroundColor: '#030303',
    scale: 2,
    useCORS: true,
    logging: false,
  });

  const dataUrl = canvas.toDataURL('image/png');

  // Try Web Share API (may fail on Safari due to async gesture chain)
  try {
    const res = await fetch(dataUrl);
    const blob = await res.blob();
    const file = new File([blob], 'duel-share.png', { type: 'image/png' });

    if (navigator.share && navigator.canShare?.({ files: [file] })) {
      await navigator.share({
        files: [file],
        title: 'DUEL',
        text: 'Check out my workout on DUEL 💪 douevenlift.com',
      });
      return;
    }
  } catch (e: any) {
    // Safari blocks navigator.share after async — fall through to download
    if (e?.name !== 'AbortError') {
      console.warn('Share API failed, falling back to download:', e?.message);
    }
  }

  // Fallback: download the image
  const link = document.createElement('a');
  link.href = dataUrl;
  link.download = 'duel-workout.png';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
